/* tslint:disable */

import React from 'react';
import styled from 'styled-components';

interface TitleProps {
  readonly h?: number;
  readonly color?: string;
  readonly w?: number;
  readonly isRow?: boolean;
  readonly f1?: boolean;
  readonly center?: boolean;
  readonly ph?: number;
};

const Box = styled.div<TitleProps>`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.center && {
      alignItems: 'center',
      justifyContent: 'center',
    }
};
  ${(props) =>
    props.f1 && {
      flex: 1,
    }
};
  ${(props) =>
    props.h && {
      height: props.h,
    }
};
  ${(props) =>
    props.ph && {
      paddingHorizontal: props.ph,
    }
};
  ${(props) =>
    props.w && {
      width: props.w,
    }
};
  ${(props) =>
    props.color && {
      backgroundColor: props.color,
    }
};
  ${(props) =>
    props.isRow && {
      flexDirection: 'row',
    }
};
  }
`

export const Row = (props: any) => <Box isRow {...props} />

export default Box



// WEBPACK FOOTER //
// ./src/atoms/Box.tsx